import "react-vertical-timeline-component/style.min.css";
import { StepButtonScheduleDetailV2 } from "../../Atoms";
import { FormScheduleDetailV2 } from "../../Molecules/FormScheduleDetailV2";
import { InvoicesScheduleV2 } from "../../Molecules/InvoicesScheduleV2";
import { HistoryModifySchedule } from "../../Templates/HistoryModifySchedule";
import { IncidentHistorySchedule } from "../../Templates/IncidentHistoryScheduleTemplate";
import { useScheduleDetailV2 } from "./useScheduleDetailV2";

export const ScheduleDetailV2 = () => {
  const { setStep, step } = useScheduleDetailV2();

  return (
    <div className="mx-auto flex w-full max-w-[1024px] flex-col gap-8 px-4 py-10 sm:px-6 lg:px-0">
      <StepButtonScheduleDetailV2 getFormNumber={setStep} />

      {step === 1 && <FormScheduleDetailV2 />}
      {step === 2 && <InvoicesScheduleV2 />}
      {step === 3 && <HistoryModifySchedule />}
      {step === 4 && <IncidentHistorySchedule />}
    </div>
  );
};
